export default {
  BusinessReportSaleAnalysis: {
    orderTime: 'Order time',
    channel: 'Channel',
    orderDate: 'Date',
    orderCount: 'New order count',
    orderItemCount: 'New order item count',
    orderAmount: 'New order sales amount',
    reverseCount: 'New refund order count',
    reverseItemCount: 'New refund item count',
    reverseAmount: 'New refund amount',
    sendOrderCount: 'Orders shipped on the day',
    sendOrderItemCount: 'Items shipped on the day',
    sendOrderAmount: 'Sales amount shipped on the day',
  }
};
